import api from './axios';

// API endpoints
const endpoints = {
  analyze: '/analyze',
  compare: '/compare',
  portfolio: '/api/v1/portfolio',
  optimalPortfolio: '/optimal-portfolio',
  users: '/api/v1/users'
};


// User Management
export const getCurrentUser = async () => {
    try {
      const response = await api.get(`${endpoints.users}/me`);
      return response;
    } catch (error) {
      throw new Error(error.response?.detail || error.message || 'Failed to fetch user info');
    }
  };
  
  export const updateUser = async (userData) => {
    try {
      const response = await api.put(`${endpoints.users}/me`, userData);
      return response.data;
    } catch (error) {
      throw new Error(error.message || 'Failed to update user info');
    }
  };
  
  export const checkEmailExists = async (email) => {
    try {
      const response = await api.get(`${endpoints.users}/check-email/${email}`);
      return response.data;
    } catch (error) {
      throw new Error(error.message || 'Failed to check email');
    }
  };
  
  //TODO: should include portfolio ID as well
  export const createUser = async (userData) => {
    try {
      const response = await api.post(endpoints.users, {
        id: userData.id,
        email: userData.email,
        firstName: userData.firstName,
        lastName: userData.lastName,
        stripePaymentMethodId: userData.stripePaymentMethodId,
        stripeCustomerId: userData.stripeCustomerId,
        planId: userData.planId,
        planPrice: userData.planPrice,
        billingInterval: userData.billingInterval
      });
      return response;
    } catch (error) {
      throw new Error(error.message || 'Failed to create user');
    }
  };
  
  // export const createUserWithPortfolio = async ({ email, portfolio }) => {
  //   try {
  //     // Create user with email in query params
  //     const userResponse = await api.post(`${endpoints.users}?email=${encodeURIComponent(email)}`);
  //     const userData = userResponse.data;
  
  //     // Create portfolio
  //     const portfolioResponse = await api.post(`${endpoints.portfolio}?user_id=${encodeURIComponent(userData.id)}`, {
  //       ...portfolio,
  //     });
  
  //     const portfolioData = portfolioResponse.data;
  
  //     return {
  //       user: userData,
  //       portfolio: portfolioData
  //     };
  //   } catch (error) {
  //     console.error('API Response:', error.response?.data);
  //     throw new Error(error.response?.data?.detail?.[0]?.msg || error.message);
  //   }
  // };
  
  